import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'resto-description-dialog',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslocoPipe,
  ],
  templateUrl: './description-dialog.component.html',
  styleUrl: './description-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionDialogComponent {
  data = inject<{
    description: string;
    save: (val: string) => {};
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<DescriptionDialogComponent>>(MatDialogRef);

  commentCtr = new FormControl<string>('');

  constructor() {
    const data = this.data;

    this.commentCtr.setValue(data.description);
  }

  submit(): void {
    this.dialogRef.close();
    this.data.save(this.commentCtr.value!);
  }
}
